import { useContext } from 'react';
import { ThemeContext } from '../theme/ThemeProvider.js';
export function useTheme() {
  return useContext(ThemeContext);
}
